const getSanitizedLink = (value: string) => {
  const newString = value.toLowerCase().replace(/[^a-zA-Z]/g, '-');

  return newString;
};

export default {
  getSanitizedLink,
};
